import { Box, ColorOptions, Text } from '@jfs/ui-new'
import { FlatList } from 'react-native-gesture-handler'
import { SvgImage } from '../../../comps/SvgImage'
import { Colors } from '../../../util/util'
import { policyDocumentsData } from '../ProfileTabComponents/ProfileTabsUtilityMapper'

const RenderItem = ({ item, index, onSelect }: { item: any; index: number; onSelect: any }) => {
  return (
    <Box key={index} pv={16} testID="policy-doc" onPress={() => onSelect(item)} underlayColor="TRANSPARENT">
      <Text fontFamily="JioType-Medium" fontSize={14} color={Colors.BLACK_14 as ColorOptions}>
        {item?.name}
      </Text>
    </Box>
  )
}

export const PolicyDocumentsModal = ({ onSelect, onDismiss, title }: any) => {
  return (
    <Box borderTopLeftRadius={24} borderTopRightRadius={24} bg="WHITE" overflow={'hidden'} pv={32} pb={10} ph={24}>
      <Box flexDirection={'row'} justifyContent="space-between" alignItems={'flex-start'} mb={22}>
        <Box width={'90%'}>
          <Text fontFamily="JioType-Black" fontSize={24}>
            {title}
          </Text>
        </Box>
        <Box testID="close-policy-doc" onPress={onDismiss} underlayColor={'TRANSPARENT'}>
          <SvgImage imageName="Close" />
        </Box>
      </Box>

      <FlatList
        data={policyDocumentsData()}
        keyExtractor={({ index }: any) => index}
        renderItem={({ item, index }) => <RenderItem index={index} item={item} onSelect={onSelect} />}
        contentContainerStyle={{ flexGrow: 1 }}
      />
    </Box>
  )
}
